export const SelectClassType = [    
  {
    attribute: "classtypeid",
    label: "Select Class Type",
    component: 'autocomplete-remote',
    validationType: "string",
    validations: {
      required: true,
    },
    optionDef: {
      type: "server-search",
      name: "name",
      url: "/admin/classtype/auto",
      operation: "like",
      min: 2,
      filter: {
        archived: 0
      }
    },
    optionConfig: {
      key: "id",
      value: "id",
      label: "name",
    },
    col: {
      sm: 12,
    },
  }
];
